export default __webpack_public_path__ + "static/Artist-6f6ac34b7c5119077217ebd827c5f2e6.png";